import React, { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../services/AuthContext';

const Home = () => {
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (isAuthenticated()) {
      navigate('/dashboard');
    }
  }, [isAuthenticated, navigate]);

  return (
    <div className="home">
      <section className="hero" style={{
        background: 'linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)',
        color: 'white',
        padding: '6rem 0',
        textAlign: 'center'
      }}>
        <div className="container">
          <h1 style={{ fontSize: '3.5rem', fontWeight: '700', marginBottom: '1rem' }}>
            CertiChain
          </h1>
          <p style={{ fontSize: '1.5rem', marginBottom: '1rem', opacity: '0.9' }}>
            Blockchain-Powered Certificate Verification
          </p>
          <p style={{ fontSize: '1.1rem', marginBottom: '2rem', maxWidth: '800px', margin: '0 auto 2rem', opacity: '0.8' }}>
            Secure, tamper-proof educational credential verification for employers.
            Instantly verify employee qualifications using blockchain technology.
          </p>
          <div className="flex gap-4 justify-center">
            <Link to="/auth" className="btn btn-primary btn-lg">
              Get Started
            </Link>
            <Link to="/verify" className="btn" style={{ background: 'rgba(255,255,255,0.2)', border: '1px solid rgba(255,255,255,0.3)', color: 'white', padding: '1rem 2rem', borderRadius: '6px', textDecoration: 'none', fontWeight: '600' }}>
              Verify Certificate
            </Link>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section style={{ padding: '4rem 0' }}>
        <div className="container">
          <h2 className="text-center mb-8" style={{ fontSize: '2.5rem', fontWeight: '600' }}>
            Why Choose CertiChain?
          </h2>
          <div className="grid grid-cols-3">
            <div className="card">
              <div className="card-body text-center">
                <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>🔒</div>
                <h3 className="card-title">Tamper-Proof Security</h3>
                <p style={{ color: '#4a5568' }}>Certificates stored on blockchain are immutable and cannot be forged.</p>
              </div>
            </div>
            <div className="card">
              <div className="card-body text-center">
                <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>⚡</div>
                <h3 className="card-title">Instant Verification</h3>
                <p style={{ color: '#4a5568' }}>Verify credentials in seconds using QR codes or certificate IDs.</p>
              </div>
            </div>
            <div className="card">
              <div className="card-body text-center">
                <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>🌍</div>
                <h3 className="card-title">Global Access</h3>
                <p style={{ color: '#4a5568' }}>Access and verify credentials from anywhere, 24/7.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* How It Works */}
      <section style={{ background: '#f7fafc', padding: '4rem 0' }}>
        <div className="container">
          <h2 className="text-center mb-8" style={{ fontSize: '2.5rem', fontWeight: '600' }}>
            How It Works
          </h2>
          <div className="grid grid-cols-3">
            <div className="card">
              <div className="card-body text-center">
                <div style={{
                  width: '60px',
                  height: '60px',
                  borderRadius: '50%',
                  background: 'var(--primary)',
                  color: 'white',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '1.5rem',
                  fontWeight: '700',
                  margin: '0 auto 1rem'
                }}>1</div>
                <h3 className="card-title">Institution Issues</h3>
                <p style={{ color: '#4a5568' }}>Educational institutions issue blockchain certificates as NFTs.</p>
              </div>
            </div>
            <div className="card">
              <div className="card-body text-center">
                <div style={{
                  width: '60px',
                  height: '60px',
                  borderRadius: '50%',
                  background: 'var(--primary)',
                  color: 'white',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '1.5rem',
                  fontWeight: '700',
                  margin: '0 auto 1rem'
                }}>2</div>
                <h3 className="card-title">Student Shares</h3>
                <p style={{ color: '#4a5568' }}>Students share their API code or QR code with employers.</p>
              </div>
            </div>
            <div className="card">
              <div className="card-body text-center">
                <div style={{
                  width: '60px',
                  height: '60px',
                  borderRadius: '50%',
                  background: 'var(--primary)',
                  color: 'white',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '1.5rem',
                  fontWeight: '700',
                  margin: '0 auto 1rem'
                }}>3</div>
                <h3 className="card-title">Instant Verification</h3>
                <p style={{ color: '#4a5568' }}>Employers verify credentials instantly using blockchain.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section style={{ padding: '4rem 0', textAlign: 'center' }}>
        <div className="container">
          <h2 style={{ fontSize: '2.5rem', fontWeight: '600', marginBottom: '1rem' }}>
            Ready to Get Started?
          </h2>
          <p style={{ fontSize: '1.2rem', color: '#4a5568', marginBottom: '2rem' }}>
            Join institutions and companies using CertiChain for secure credential verification.
          </p>
          <div className="flex gap-4 justify-center">
            <Link to="/auth" className="btn btn-primary btn-lg">
              Start Now
            </Link>
            <Link to="/student-access" className="btn btn-secondary btn-lg">
              Access Certificate
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;